import clsx from 'clsx';
import React from 'react';

import Button from '@/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/components/common/Elements/Icon/Icon';

const Checkbox = (props) => {
  const handleChange = () => {
    if (props.onChange) {
      props.onChange(props.value);
    }
  };

  const { disabled = false, checkboxSize = '20px' } = props;
  const onClick = !disabled ? handleChange : null;

  return (
    <Button
      className={clsx(
        'container--checkboxItem',
        'tw-cursor-pointer',
        'tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-p-0',
        'tw-border-solid tw-border-[2px] tw-rounded-[2px]',
        props.checked
          ? 'tw-bg-cfo-blue-700 tw-border-cfo-blue-700'
          : 'tw-bg-white tw-border-cfo-black',
        props.className
      )}
      style={{ width: checkboxSize, height: checkboxSize }}
      onClick={onClick}
    >
      {props.checked && (
        <Icon
          className={clsx('tw-text-white')}
          style={{ fontSize: checkboxSize }}
          icon={ICONS.check}
        />
      )}
    </Button>
  );
};

Checkbox.defaultProps = {
  checked: false,
};

export default Checkbox;
